export class UserContact {
	uid: string = "";
  	cellPhone: string = "";
	preferredPhone: string = "";
	primaryEmail: string = "";
	secondaryEmail: string = "";
}
